import { createContext, useContext } from 'react';

export interface TicketsContextProps {
  getTickets();
  severity: Record<string, any>[];
  status: Record<string, any>;
  provider: Record<string, any>;
  resourceTypeOptions: Record<string, any>[];
  resourceType: Record<string, any>;
  assignee: Record<string, any>;
  assigneeOptions: Record<string, any>[];
  isOverDueDate: boolean;
  sortOrder: string;
  sortField: string;
  updateValue(field, value);
  // Sets sortField and sortOrder in the URL together.
  updateSort(sortInfo: { sortField?: string; sortOrder?: string });
}

export const TicketsContext = createContext<TicketsContextProps>({
  getTickets: () => {},
  severity: [],
  status: {},
  provider: {},
  resourceTypeOptions: [],
  resourceType: {},
  assignee: {},
  assigneeOptions: [],
  isOverDueDate: false,
  sortOrder: '',
  sortField: '',
  updateValue: () => {},
  updateSort: () => {},
});

export const TicketsContextProvider = TicketsContext.Provider;

export const useTicketsContext = () => useContext(TicketsContext);
